// Best-effort haptic feedback (mobile browsers that support the Vibration API).
export function haptic(pattern = [40, 30, 80]) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(pattern);
  } catch { /* ignore */ }
}

export const HAPTIC_SUCCESS = [30, 40, 30, 40, 90];
